var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading"},[_c('img',{attrs:{"src":require("../assets/loading.gif"),"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }